import "@fontsource-variable/plus-jakarta-sans";
import "./index.css";
import { Toaster } from "@love-cpmd/ui";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./app/router";
import { API_MODE, ApiError } from "./lib/api";
import { AuthProvider } from "./lib/auth";

const NO_RETRY = new Set(["AUTH", "FORBIDDEN", "NOT_FOUND", "VALIDATION"]);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (count, error) => count < 1 && !(error instanceof ApiError && NO_RETRY.has(error.code)),
      // Online, coming back to the tab shows what teammates changed meanwhile.
      refetchOnWindowFocus: API_MODE === "http",
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);

// PWA: offline shell + installability (Android "Add to Home screen").
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`).catch(() => {
      /* non-fatal */
    });
  });
}
